import { render, staticRenderFns } from "./InitialMessageModal.vue?vue&type=template&id=79e2e208&scoped=true"
import script from "./InitialMessageModal.vue?vue&type=script&lang=js"
export * from "./InitialMessageModal.vue?vue&type=script&lang=js"
import style0 from "./InitialMessageModal.vue?vue&type=style&index=0&id=79e2e208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e2e208",
  null
  
)

export default component.exports